<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fmtitle">List of Plates</h2>
<p class="list"><span href="#/xhtml/22_Plates#p1" title="Link target outside of Sample"><span class="list">1.</span> A Review at Hounslow Heath by Denis Dighton.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p2" title="Link target outside of Sample"><span class="list">2.</span> The Crown &amp; Thistle, Abingdon-on-Thames.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p3" title="Link target outside of Sample"><span class="list">3.</span> The Cavalry Barracks at Canterbury.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p4" title="Link target outside of Sample"><span class="list">4.</span> Dutch schuyts.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p5" title="Link target outside of Sample"><span class="list">5.</span> A Surgeon and an Inspector of Hospitals.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p6" title="Link target outside of Sample"><span class="list">6.</span> Study of Sir Frederick Ponsonby by Thomas Heaphy.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p7" title="Link target outside of Sample"><span class="list">7.</span> Frederick Ponsonby’s Waterloo Sword.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p8" title="Link target outside of Sample"><span class="list">8.</span> The 12th Light Dragoons by Denis Dighton.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p9" title="Link target outside of Sample"><span class="list">9.</span> Captain William Hay, 12th Light Dragoons, circa 1820.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p10" title="Link target outside of Sample"><span class="list1">10.</span> A view of Quatre Bras on 19 June 1815 by Thomas Stoney, with corpses still littering the ground.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p11" title="Link target outside of Sample"><span class="list1">11.</span> Farm of Quatre Bras just before it was shamefully destroyed.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p12" title="Link target outside of Sample"><span class="list1">12.</span> Courbevoie Barracks.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p13" title="Link target outside of Sample"><span class="list1">13.</span> The Waterloo Memorial to the 12th Light Dragoons. One of the first memorials to include the names of all ranks killed.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p14" title="Link target outside of Sample"><span class="list1">14.</span> Surgeon’s Regulation Case circa 1812.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p15" title="Link target outside of Sample"><span class="list1">15.</span> Chateau Marais, Argenteuil.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p16" title="Link target outside of Sample"><span class="list1">16.</span> Chateau Puteaux before its final destruction after a fire in 1881.</span></p>
<p class="list"><span href="#/xhtml/22_Plates#p17" title="Link target outside of Sample"><span class="list1">17.</span> Chateau de Bacqueville.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_List.vue?40902ef8